import React from "react";

interface DiamonIconProps {
  className?: string;
  onClick?: () => void;
}

export const DiamonIcon = ({ className, onClick }: DiamonIconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    id="diamond-icon-wt"
  >
    <path
      d="M26.1523 11.25H13.8125C13.6719 11.25 13.5312 11.3555 13.4609 11.4609L9.91016 17.1914C9.83984 17.332 9.83984 17.543 9.94531 17.6836L19.6484 29.1094C19.8242 29.3203 20.1406 29.3203 20.3164 29.1094L30.0195 17.6836C30.125 17.543 30.125 17.332 30.0547 17.1914L26.5391 11.4609C26.4336 11.3555 26.293 11.25 26.1523 11.25ZM25.6953 12.5156L28.2969 16.875H25.3789L23.375 12.5156H25.6953ZM22.0039 12.5156L23.9727 16.875H15.9922L17.9961 12.5156H22.0039ZM14.2695 12.5156H16.5898L14.5859 16.875H11.668L14.2695 12.5156ZM12.0195 18H14.5859L17.4688 24.75L12.0195 18ZM15.957 18H24.0078L20 27.2812L15.957 18ZM22.5312 24.75L25.3789 18H27.9453L22.5312 24.75Z"
      fill="black"
    />
  </svg>
);

DiamonIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
